enum ViewType {
  LIST_VIEW = 'ListView',
  POWER_VIEW = 'PowerView',
  SIDE_RAIL_VIEW = 'SideRailView'
}

export default ViewType;
